import React from "react";

import "./Spinner.styles.scss";

const Spinner = () => {
	return <div className="spinner" />;
};

export default Spinner;
